export const queryKeys = {
  CRM_FIELD: 'CRM_FIELD',
  LEAD_EMPLOYEE_ALL: 'LEAD_EMPLOYEE_ALL',
  LEAD_TASK_FILTER: 'LEAD_TASK_FILTER',
  GLOBAL_DUPLICATE_CONTROL_SEARCH_ALL_DUPLICATE: 'GLOBAL_DUPLICATE_CONTROL_SEARCH_ALL_DUPLICATE',
  PIPE_ALL: 'PIPE_ALL',
  PIPE_ALL_CHECK: 'PIPE_ALL_CHECK',
  LEAD_FILTER_V2: 'LEAD_FILTER_V2',
  REASONS_FOR_REFUSAL: 'REASONS_FOR_REFUSAL',
  TAG_ALL: 'TAG_ALL',
  LEAD_TABLE_FILTER_V2: 'LEAD_TABLE_FILTER_V2',
  LEAD_TABLE_FILTER_LEAD_IDS: 'LEAD_TABLE_FILTER_LEAD_IDS',
  PIPE_TEMPLATE_ID: 'PIPE_TEMPLATE_ID',
  PIPE_TEMPLATE: 'PIPE_TEMPLATE',
  PIPE_TEMPLATE_ALL: 'PIPE_TEMPLATE_ALL',
  DUPLICATE_CONTROL_CONFIG: 'DUPLICATE_CONTROL_CONFIG',
  LEAD_TASK_TYPE_ALL: 'LEAD_TASK_TYPE_ALL',
  CRM_FACEBOOK_REDIRECT_URL: 'CRM_FACEBOOK_REDIRECT_URL',
  CRM_FACEBOOK_ACCOUNT: 'CRM_FACEBOOK_ACCOUNT',
  CRM_FACEBOOK_APP_PIPE: 'CRM_FACEBOOK_APP_PIPE',
  CRM_FACEBOOK_PAGES: 'CRM_FACEBOOK_PAGES',
  CRM_FACEBOOK_LEAD_FORM: 'CRM_FACEBOOK_LEAD_FORM',
  CRM_FACEBOOK_LEAD_FORM_ID: 'CRM_FACEBOOK_LEAD_FORM_ID',
  CRM_FACEBOOK_LEAD_FORM_FIELD: 'CRM_FACEBOOK_LEAD_FORM_FIELD',
  CRM_FACEBOOK_LEAD_FORM_PIPE_STATUS: 'CRM_FACEBOOK_LEAD_FORM_PIPE_STATUS',
  LEAD_ID: 'LEAD_ID',
  LEAD_STAT: 'LEAD_STAT',
  CRM_FACEBOOK_EXPIRED: 'CRM_FACEBOOK_EXPIRED',
  LEAD_MAP_VIEW: 'LEAD_MAP_VIEW',
  MAP_VIEW_CONFIG: 'MAP_VIEW_CONFIG',
  LEAD_FILTER_PARAMS: 'LEAD_FILTER_PARAMS',
  GOOGLE_SHEETS_ACCOUNT: 'GOOGLE_SHEETS_ACCOUNT',
  LEAD_FORCE_ATTACH_REQUIRED_FIELDS: 'LEAD_FORCE_ATTACH_REQUIRED_FIELDS',
  LEAD_GROUP_TABLE_FILTER_INFINITY: 'LEAD_GROUP_TABLE_FILTER_INFINITY'
};
